export const JOB_WIDTH_LEFT_COLUMN = 242;
export const JOB_WIDTH_RIGHT_COLUMN = 932;
export const PADDING = 24;
export const JOB_WIDTH_FULL = JOB_WIDTH_LEFT_COLUMN + JOB_WIDTH_RIGHT_COLUMN - PADDING;
